import { Card, CardBody, Col } from "reactstrap";
import { Badges, H1, H2, H3, H4, H5, H6 } from "../../../AbstractElements";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { BadgeHeadingText, BadgeHeadingsExample } from "../../../Constants/Constants";
import { BadgeHeadingSubTitle } from "../../../Data/UiKits/Tag&Pills";

const BadgeHeading = () => {
  return (
    <Col sm="12" xl="6" className="box-col-12">
      <Card className="height-equal">
        <CommonCardHeader title={BadgeHeadingsExample} span={BadgeHeadingSubTitle} />
        <CardBody className="badge-heading">
          <H1>{BadgeHeadingText}<Badges color="secondary">{"New"}</Badges></H1>
          <H2>{BadgeHeadingText}<Badges color="secondary">{"New"}</Badges></H2>
          <H3>{BadgeHeadingText}<Badges color="secondary">{"New"}</Badges></H3>
          <H4>{BadgeHeadingText}<Badges color="secondary">{"New"}</Badges></H4>
          <H5>{BadgeHeadingText}<Badges color="secondary">{"New"}</Badges></H5>
          <H6>{BadgeHeadingText}<Badges color="secondary">{"New"}</Badges></H6>
        </CardBody>
      </Card>
    </Col>
  );
};
export default BadgeHeading;
